import React from 'react';
import { useYearContext } from '../../contexts/YearContext';

interface WordReportGeneratorProps {
  companyId?: number;
}

export function WordReportGenerator({ companyId }: WordReportGeneratorProps) {
  const { selectedYear, currentCompany } = useYearContext();
  const [isGenerating, setIsGenerating] = React.useState(false);
  
  const company_id = companyId || currentCompany?.id;
  const reporting_year = selectedYear || new Date().getFullYear();
  
  const generateWord = async () => {
    if (!company_id) {
      alert('Please select a company first');
      return;
    }
    
    try {
      setIsGenerating(true);
      
      const token = localStorage.getItem('access_token');
      const API_BASE =
        (import.meta as any).env?.VITE_API_BASE_URL ||
        `${window.location.protocol}//${window.location.hostname}:9000`;
      const response = await fetch(
        `${API_BASE}/api/reports/word/${company_id}?reporting_year=${reporting_year}`,
        {
          method: 'GET',
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          credentials: 'include',
        }
      );
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to generate report');
      }
      
      // Download the file
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `GHG_Report_${company_id}_${reporting_year}.docx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error generating Word report:', error);
      alert(`Error generating report: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsGenerating(false);
    }
  };
  
  return (
    <button
      onClick={generateWord}
      disabled={isGenerating || !company_id}
      className={`inline-flex items-center px-4 py-2 rounded-md transition-colors ${
        isGenerating || !company_id
          ? 'bg-gray-400 text-gray-200 cursor-not-allowed' 
          : 'bg-green-600 text-white hover:bg-green-700'
      }`}
    >
      {isGenerating ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
          Generating...
        </>
      ) : (
        <>
          <i data-feather="file-text" className="w-4 h-4 mr-2"></i>
          Download Word Report
        </>
      )}
    </button>
  );
}

